var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-empty"},[_c('font-awesome-icon',{staticClass:"table-empty__icon",attrs:{"icon":_vm.dataIconList}}),_c('h4',{staticClass:"table-empty__text"},[_vm._v(" No avaliable data ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }